module.exports = __webpack_public_path__ + "img/DSC_0286_4.e4482dec.jpg";